import { API } from "../../../api/constants";
import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios";

export const getSessionsGroupedByEmployee = (startAt: Date, endAt: Date) =>
    authenticatedAxiosInstance.get(API + `/sessions/grouped-by-employee?startAt=${startAt}&endAt=${endAt}`).then((res) => res.data)
